function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M269.3 94.2l-12.8-25.4-100.5 50V28.3h-28.5v90.5l-100.6-50-12.7 25.4 95.7 47.5-95.7 47.6 12.7 25.4 100.6-50v90.4H156v-90.4l100.5 50 12.8-25.4-95.7-47.6z"
})));